import { ChangeEvent, useCallback } from "react"
import { css } from "@emotion/css"
import MUITab, { TabProps } from "@material-ui/core/Tab"
import MUITabs, { TabsProps } from "@material-ui/core/Tabs"

const styles = {
  root: css`
    min-height: 32px;
  `,
  underline: css`
    border-bottom: 2px solid var(--light-grey);
    height: 32px;
    min-width: fit-content;
  `,
  selected: css`
    height: 2px;
  `,
}

export const styledTabsProps: TabsProps = {
  classes: {
    root: styles.root,
    flexContainer: styles.underline,
    indicator: styles.selected,
  },
  indicatorColor: "primary",
  textColor: "primary",
}

export type StyledTabsProps = TabsProps & {
  onTabChange: (value: any) => void
}

export function Tabs({ onTabChange, ...rest }: StyledTabsProps) {
  const handleChange = useCallback(
    (_: ChangeEvent<{}>, value: any) => {
      onTabChange(value)
    },
    [onTabChange],
  )

  return (
    <MUITabs
      classes={{
        root: styles.root,
        flexContainer: styles.underline,
        indicator: styles.selected,
      }}
      indicatorColor="primary"
      textColor="primary"
      onChange={handleChange}
      {...rest}
    />
  )
}

const tabStyles = {
  button: css`
    min-height: 32px;
    text-transform: capitalize;
    padding: 8px 24px;
    &:hover {
      border-radius: 3px;
      box-shadow: 0 2px 9px 0 var(--lighter-grey);
      background-color: var(--light-grey-2);
    }
  `,
  label: css`
    font-size: 14px;
    font-weight: 400;
    color: var(--black);
    letter-spacing: 0;
  `,
  selected: css`
    span {
      font-weight: 600;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  `,
  disabled: css`
    &.Mui-disabled {
      > span {
        color: var(--grey);
      }
    }
  `,
}

export const styledTabClasses: TabProps["classes"] = {
  root: tabStyles.button,
  wrapper: tabStyles.label,
  selected: tabStyles.selected,
}

export function Tab(props: TabProps) {
  return (
    <MUITab
      classes={{
        root: tabStyles.button,
        wrapper: tabStyles.label,
        selected: tabStyles.selected,
        textColorPrimary: tabStyles.disabled,
      }}
      {...props}
    />
  )
}
